<template>
  <div class="addCompetitionManagement">
    <div class="topTitle">
      <el-page-header @back="goback" content="新增比赛"> </el-page-header>
    </div>
    <div class="table">
      <el-form label-position="top" :rules="rules" ref="contest" :model="contest">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="比赛名称" required prop="title">
              <el-input v-model="contest.title" placeholder="请输入比赛名称" maxlength="200" show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="报名方式" required prop="sign_mode">
              <el-select class="difficulty-select" size="small" v-model="contest.sign_mode" style="width:100%">
                <el-option label="自由报名" :value="1"></el-option>
                <el-option label="报名审核" :value="2"></el-option>
                <el-option label="由组织方拉人" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="比赛赛制" required prop="rule_type">
              <el-radio class="radio" v-model="contest.rule_type" :label="1">ACM</el-radio>
              <el-radio class="radio" v-model="contest.rule_type" :label="2">OI</el-radio>
              <el-radio class="radio" v-model="contest.rule_type" :label="3">IOI</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="可选编程语言">
              <el-checkbox-group v-model="contest.languages">
                <el-checkbox v-for="item in languagess" :label="item.id" :key="item.id">{{ item.name }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="主办方" required prop="sponsor">
              <el-input v-model="contest.sponsor" placeholder="请输入比赛名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="比赛日期" required prop="value1">
              <el-date-picker style="width: 100%;" @blur="changeTime" v-model="contest.value1" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" :rules="[
                  { required: true, message: '请选择日期', trigger: 'blur' },
                ]" placement="bottom-start">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="比赛是否显示">
              <el-radio class="radio" v-model="contest.post_state" :label="1">是</el-radio>
              <el-radio class="radio" v-model="contest.post_state" :label="0">否</el-radio>
            </el-form-item>
          </el-col>

          <div v-if="markdownShow1">
            <el-col :span="24" v-if="is_md">
              <el-form-item label="描述" required prop="description">
                <markdownShow @changeMardown="changeMardown" :markdown="contest.description" @SaveMarkDown="SaveMarkDown">
                </markdownShow>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-else>
              <el-form-item label="描述" required prop="description">
                <Tinymce v-model="contest.description"></Tinymce>
              </el-form-item>
            </el-col>
          </div>

          <el-col :span="24" v-if="markdownShow2">
            <el-form-item label="公告">
              <markdownShow @changeMardown="changeMardown1" :markdown="contest.notic" @SaveMarkDown="SaveMarkDown1">
              </markdownShow>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-button type="primary" @click="save('contest')"> 保存比赛 </el-button>
    </div>
  </div>
</template>

<script>
import Tinymce from '@/components/Tinymce'
import { tchAddOrUpdateOjContest } from '@/api/educational.js'
import markdownShow from '@/components/markdownShow'

export default {
  components: {
    Tinymce,
    markdownShow,
  },
  data() {
    return {
      markdownShow1: true,
      markdownShow2: true,
      is_md: true,
      difficultyId: '',
      contest: {
        value1: [],
        sponsor: '',
        post_state1: true,
        rank_state1: true,
        rule_type: 3,
        title: '',
        description: '',
        start_date: '',
        end_date: '',
        post_state: 1,
        rank_state: true,
        sign_mode: '',
        notic: '',
        languages: ['0', '1', '2'],
      },
      //可选编程语言
      languagess: [
        {
          id: '0',
          name: 'C',
        },
        {
          id: '1',
          name: 'C++',
        },
        {
          id: '2',
          name: 'Python3',
        },
      ],
      rules: {
        value1: [
          {
            required: true,
            message: '请选择比赛开始-终止时间',
            trigger: 'blur',
          },
          {
            required: true,
            message: '请选择比赛开始-终止时间',
            trigger: 'change',
          },
        ],

        sponsor: [
          {
            required: true,
            message: '请输入主办方',
            trigger: 'change',
          },
          {
            required: true,
            message: '请输入主办方',
            trigger: 'blur',
          },
        ],
        title: [
          {
            required: true,
            message: '请输入题目名称',
            trigger: 'change',
          },
          {
            required: true,
            message: '请输入题目名称',
            trigger: 'blur',
          },
        ],

        description: [
          {
            required: true,
            message: '请输入题单描述',
            trigger: 'change',
          },
          {
            required: true,
            message: '请输入题单描述',
            trigger: 'blur',
          },
        ],

        sign_mode: [
          {
            required: true,
            message: '请选择报名方式',
            trigger: 'change',
          },
          {
            required: true,
            message: '请选择报名方式',
            trigger: 'blur',
          },
        ],
        rule_type: [
          {
            required: true,
            message: '请选择模式',
            trigger: 'change',
          },
          {
            required: true,
            message: '请选择模式',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  created() {
    console.log(this.$route.query.type, 335)
    if (this.$route.query.type === 'edit') {
      console.log(JSON.parse(sessionStorage.getItem('addMatch')), 1245)

      this.is_md = JSON.parse(sessionStorage.getItem('addMatch')).is_md
      this.contest = JSON.parse(sessionStorage.getItem('addMatch'))
      console.log(this.contest.start_date, 123456)
      console.log(this.contest.end_date, 123456)
      this.contest.value1 = []
      // this.contest.value1.push(this.contest.start_date)
      this.contest.value1 = [this.contest.start_date, this.contest.end_date]
      console.log(this.contest.value1, 123456)

      this.difficultyId = JSON.parse(sessionStorage.getItem('addMatch')).id
      console.log(this.difficultyId, 3356)

      console.log(JSON.parse(sessionStorage.getItem('addMatch')).rank_state)
      // this.contest.rank_state1 = JSON.parse(sessionStorage.getItem('addMatch')).rank_state
      this.contest.post_state = JSON.parse(
        sessionStorage.getItem('addMatch')
      ).post_state
      if (JSON.parse(sessionStorage.getItem('addMatch')).post_state == false) {
        this.contest.post_state = 0
      } else {
        this.contest.post_state = 1
      }
      console.log(this.contest, 335)
      this.contest.languages = JSON.parse(this.contest.languages)
      console.log(JSON.parse(this.contest.languages), 3356)

      // if (JSON.parse(sessionStorage.getItem('addMatch')).post_state === true) {
      //   this.contest.post_state = '1'
      // } else {
      //   this.contest.post_state = '0'

      // }
      // if (JSON.parse(sessionStorage.getItem('addMatch')).rank_state === true) {
      //   this.contest.rank_state = '1'
      // } else {
      //   this.contest.rank_state = '0'

      // }
    }
  },
  mounted() {
    this.markdownShow2 = false
    this.markdownShow1 = false
    this.$nextTick(() => {
      this.markdownShow2 = true
      this.$nextTick(() => {
        this.markdownShow1 = true
      })
    })
  },
  methods: {
    changeTime(val) {
      this.$forceUpdate()

      console.log(val, 123456)
    },
    changeMardown1(val) {
      this.contest.notic = val
    },
    SaveMarkDown1(md, html) {
      console.log('保存markdown')
      console.log(md, 45412)
      console.log(html, 13223)
      this.contest.notic = md
    },
    changeMardown(val) {
      this.contest.description = val
    },
    SaveMarkDown(md, html) {
      console.log('保存markdown')
      console.log(md, 45412)
      console.log(html, 13223)
      this.contest.description = md
    },
    startTime(val) {
      console.log(val)
      const yy = new Date().getFullYear()
      const MM =
        new Date().getMonth() + 1 < 10
          ? '0' + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1
      const dd =
        new Date().getDate() < 10
          ? '0' + new Date().getDate()
          : new Date().getDate()
      const HH =
        new Date().getHours() < 10
          ? '0' + new Date().getHours()
          : new Date().getHours()
      const mm =
        new Date().getMinutes() < 10
          ? '0' + new Date().getMinutes()
          : new Date().getMinutes()
      const ss =
        new Date().getSeconds() < 10
          ? '0' + new Date().getSeconds()
          : new Date().getSeconds()
      // return yy + '-' + MM + '-' + dd + ' ' + HH + ':' + mm + ':' + ss
      let newTime = yy + '-' + MM + '-' + dd + ' ' + HH + ':' + mm + ':' + ss
      console.log(newTime)
      // if (val < newTime) {
      //   this.$message.warning('开始时间不能小于当前时间')
      // }
    },
    endTime(val) {
      console.log(val)

      // if (this.contest.start_date > val) {
      //   this.$message.warning('结束时间不呢小于开始时间')
      // }
    },
    save(formName) {
      const yy = new Date().getFullYear()
      const MM =
        new Date().getMonth() + 1 < 10
          ? '0' + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1
      const dd =
        new Date().getDate() < 10
          ? '0' + new Date().getDate()
          : new Date().getDate()
      const HH =
        new Date().getHours() < 10
          ? '0' + new Date().getHours()
          : new Date().getHours()
      const mm =
        new Date().getMinutes() < 10
          ? '0' + new Date().getMinutes()
          : new Date().getMinutes()
      const ss =
        new Date().getSeconds() < 10
          ? '0' + new Date().getSeconds()
          : new Date().getSeconds()
      // return yy + '-' + MM + '-' + dd + ' ' + HH + ':' + mm + ':' + ss
      let newTime = yy + '-' + MM + '-' + dd + ' ' + HH + ':' + mm + ':' + ss
      console.log(newTime)

      // if (this.contest.start_date < newTime) {
      //   this.$message.warning('开始时间不能小于当前时间')
      //   return false
      // }
      // if (this.contest.start_date > this.contest.end_date) {
      //   this.$message.warning('结束时间不呢小于开始时间')
      //   return false

      // }
      if (this.contest.languages.length === 0) {
        this.$message.warning('请至少选择一直语言')
        return false
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.difficultyId) {
            console.log(123, 45)
            tchAddOrUpdateOjContest({
              sponsor: this.contest.sponsor,
              is_md: this.is_md,
              languages: JSON.stringify(this.contest.languages),
              id: this.difficultyId,
              title: this.contest.title,
              description: this.contest.description,
              start_date: this.contest.value1[0],
              end_date: this.contest.value1[1],
              post_state: this.contest.post_state,
              rank_state: this.contest.rank_state,
              sign_mode: this.contest.sign_mode,
              rule_type: this.contest.rule_type,
              notic: this.contest.notic,
            }).then((res) => {
              console.log(res, 33321)
              this.$message.success('修改比赛成功!')

              this.goback()
            })
          } else {
            tchAddOrUpdateOjContest({
              sign_state: this.contest.sign_state,
              sponsor: this.contest.sponsor,
              is_md: this.is_md,
              languages: JSON.stringify(this.contest.languages),
              title: this.contest.title,
              description: this.contest.description,
              start_date: this.contest.value1[0],
              end_date: this.contest.value1[1],
              post_state: this.contest.post_state,
              rank_state: this.contest.rank_state,
              sign_mode: this.contest.sign_mode,
              rule_type: this.contest.rule_type,
              notic: this.contest.notic,
            }).then((res) => {
              console.log(res, 33321)
              this.$message.success('新建比赛成功!')
              this.goback()
            })
          }
        }
      })
    },
    chanegState(val) {
      console.log(val)
      if (val === true) {
        this.contest.rank_state = '1'
      } else {
        this.contest.rank_state = '0'
      }
      console.log(this.contest.rank_state)
    },
    chanegPostState(val) {
      console.log(val)

      if (val === true) {
        this.contest.post_state = '1'
      } else {
        this.contest.post_state = '0'
      }
    },
    // addIPRange() {
    //   this.contest.allowed_ip_ranges.push({ value: '' })
    // },
    // removeIPRange(range) {
    //   let index = this.contest.allowed_ip_ranges.indexOf(range)
    //   if (index !== -1) {
    //     this.contest.allowed_ip_ranges.splice(index, 1)
    //   }
    // },
    goback() {
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss" scoped>
.addCompetitionManagement {
  height: 100%;
  width: 100%;
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;

  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.table {
  margin: 10px;
  background: 10px;
  padding: 20px;
  background: #fff;
  border-radius: 5px;
  box-sizing: border-box;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}
</style>
